"use strict";

exports.__esModule = true;
exports.endOfDay = exports.endOfCurrentDay = void 0;
exports.getDate = getDate;
exports.toDateMillis = exports.startOfDay = exports.getMinDate = void 0;
exports.toDateString = toDateString;
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var JANUARY_1_2008 = 1199145600000;

/**
 * Return the appropriate workday id for a particular date.
 */
function getDate(input) {
  return new Date(input);
}

/**
 * Convert to date string regardless of timezone and when the input is not date return without any change
 */
function toDateString(selected) {
  var convertToDateString = function convertToDateString(date) {
    if (date instanceof Date) {
      return (0, _moment["default"])(date).format().slice(0, 10);
    }
    return date;
  };
  return Array.isArray(selected) ? selected.map(function (date) {
    return convertToDateString(date);
  }) : convertToDateString(selected);
}

/**
 * Default Min date for date picker
 * @returns {Date}
 */
var getMinDate = exports.getMinDate = function getMinDate() {
  return new Date(JANUARY_1_2008);
};
var toDateMillis = exports.toDateMillis = function toDateMillis(date) {
  return new Date(date).getTime();
};
var endOfCurrentDay = exports.endOfCurrentDay = function endOfCurrentDay() {
  return (0, _moment["default"])().endOf("day").toDate();
};
var startOfDay = exports.startOfDay = function startOfDay(day) {
  return (0, _moment["default"])(day).startOf("day").toDate();
};
var endOfDay = exports.endOfDay = function endOfDay(day) {
  return (0, _moment["default"])(day).endOf("day").toDate();
};